<app-feed
  class="feed"
  [feed]="notifications$ | async"
  [enableVirtualScroll]="false"
  [noItemsOptions]="noNotificationsOptions"
>
  <ng-template let-notification="feedItem">
    <app-notifications-list-item-old
      *ngIf="showLegacyNotificationItem; else notificationListItemV2"
      [notification]="notification"
      [trackingScreenName]="trackingScreenName"
      (onClickItem)="onClickItem($event)"
      (onDismissItem)="onDismissItem($event)"
    >
    </app-notifications-list-item-old>

    <ng-template #notificationListItemV2>
      <app-notifications-list-item
        [notification]="notification"
        [trackingScreenName]="trackingScreenName"
        (onClickItem)="onClickItem($event)"
        (onDismissItem)="onDismissItem($event)"
      >
      </app-notifications-list-item>
    </ng-template>
  </ng-template>
</app-feed>
